export default __webpack_public_path__ + "static/service-icon5-aa0faa64f811d03d240fffef096ecd4a.png";